export default __webpack_public_path__ + "media/images/icons_button/btn-icon6-fbfd286f31a429ca4a5314efdcdb481a.png";